if(typeof perf_hooks === 'undefined') { var e = new Error("Cannot find module 'perf_hooks'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = perf_hooks;